import { Text, View, Image } from 'components';
import { Modal } from 'components/Modal';
// import Modal from 'react-modal';
import Base, { Config } from 'components/megatron/Base';
import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


interface Props {
  data: any 
}


export default class ResumeItem extends Base<Props> {
  

  public didMount(){
    
  }

  public render() {
    const { data } = this.props;

    const another_skills = data && Array.isArray(data.another_skills)
      ? (data.another_skills || []).filter(e => e === '打炮头')
      : [];

    return (
      <View className={styles.container}>
        
        {data && (
          <View className={this.cx(
            styles.item, 
            data.ad? styles.adstyle: ''
          )} onClick={this.handleClick}>
            <View className={styles.up}>
              <View className={styles.left}>
                <View className={styles.name}>
                  <Text className={styles.p}>{data.realname}</Text>
                  <Text className={styles.span}>{data.utime}发布</Text>
                </View>
                <View className={styles.info}>
                  <Text className={styles.p}>{this.getWorkTime(data.working_age)}</Text>
                  <View className={styles.dvd} />
                  <Text className={styles.p}>{data.address}</Text>
                  <Text className={styles.tag}>{this.getLocationText(data.location)}</Text>
                </View>
              </View>
              <View className={styles.avatar}>
                <Image className={styles.img} src={data.image}/>
                {data.ad && 
                  <Text className={styles.top}>简历置顶</Text>
                }
              </View>
            </View>
            <View className={styles.down}>
              <View className={styles.tags}>

                <Text className={cx(styles.tag, {
                  [styles.yellow]: (data.alias == '铲车' || data.car_type == '铲车')
                })}>{data.alias || data.car_type}</Text>
                <Text className={cx(styles.tag, styles.gray)}>{this.salary}/月</Text>

                {another_skills.length > 0 &&
                  another_skills.map((s, idx) => {
                    return (
                      <Text key={idx} className={cx(styles.tag, styles.bgBlue)}>
                        {s}
                      </Text>
                    );
                  })}
                {(data && data.maintain) && (
                  <Text className={cx(styles.tag, styles.bgBlue)}>懂维修</Text>
                )}

              </View>
              <View className={styles.desc}>
                <Text className={styles.p}>{data.description.replace(/\n|\r/g,"")}</Text>
              </View>
            </View>
          </View>
        )}

      </View>
    );
  }

  private WorkTimeRange = [
    { name: '学徒', value: 0 },
    { name: '1-3年', value: 1 },
    { name: '3-5年', value: 3 },
    { name: '5-10年', value: 5 },
    { name: '10-15年', value: 10 },
    { name: '15年以上', value: 15 }
  ]

  private Locations = [
    { value: '1', name: '只在本市干' },
    { value: '2', name: '本市和周边都可以去' },
    { value: '3', name: '本省内都可以去' },
    { value: '4', name: '外省也可以去' }
  ]

  private getWorkTime = e => {
    const num = [15, 10, 5, 3, 1, 0].find(res => res <= e)
    const result = this.WorkTimeRange.find(res => res.value == num)
    return result? result.name: ''
  }

  private getLocationText = val => {
    let res = this.Locations.find(res => +res.value == +val)
    return res? res.name: ''
  }

  private handleClick = () => {
    // const { data } = this.props
    // data && this.navigator.push('resumeDetail',{id: data.id}
  }

  private get salary() {
    const { data } = this.props
    if(!data){
      return ''
    }
    let salary_txt;
    if (data.max_salary == 0) {
      salary_txt = '面议';
    } else if (data.base_salary == 12000) {
      salary_txt = '12000以上';
    } else if (data.max_salary) {
      salary_txt = `${data.base_salary}-${data.max_salary}`;
    }

    return salary_txt;
  }
  
  
}
